const projects = [
  {
    id: 3,
    title: "College Performance Analysis and Graduation Rate Prediction",
    description: "This project involves a comprehensive data analysis and machine learning pipeline applied to the College.csv dataset, which contains various attributes for 777 universities and colleges. The primary goal is to gain insights into factors influencing college characteristics and to build a predictive model for Grad.Rate (Graduation Rate), a key indicator of institutional success.",
    image: "/icons/projects/cpa-grp.png",
    techStack: ["Python", "Pandas", "Matplotlib", "Numpy", "Sklearn"],
    githubLink: "https://github.com/HariniS1018/College-Performance-Analysis-and-Graduation-Rate-Prediction",
    demoLink: "",
    borderColor: "#ede15b",
    techStackColor: "#f2e982ff"
  },
  {
    id: 2,
    title: "Plant Disease Detection and Recommendation System",
    description: "This comprehensive system detects plant diseases using deep learning and provides recommendations for treatment. It provides farmers with flexible mobile diagnostics (online/offline) and administrators with web-based data management for crops like Banana, Coconut, Sugarcane, Cotton, Corn, and Groundnut",
    image: "/icons/projects/pddrs-2.jpg",
    techStack: ["Python", "Node.js", "Express.js", "React.js", "TensorFlow"],
    githubLink: "",
    demoLink: "",
    borderColor: "#228B22",
    techStackColor: "#9ACD9A"
  },
  {
      id: 1,
      title: "Robust-RAG",
      description: "The Robust RAG System incorporates advanced context filtering and scoring mechanisms to provide highly reliable responses. It further distinguishes itself by facilitating cross-cloud data ingestion from GCP, AWS S3, and Chroma database, and supporting diverse LLM integrations including OpenAI, Gemini, and Claude Sonnet.",
      image: "/icons/projects/robust-rag-2.png",
      techStack: ["Python", "LangChain", "Streamlit", "Fast API"],
      githubLink: "https://github.com/HariniS1018/Robust-RAG",
      demoLink: "",
    borderColor: "#0096FF",
    techStackColor: "#A0D7FF"
    },
];

export default projects;